import connectToStores from 'alt-utils/lib/connectToStores'
import { ResponsiveDialog  } from 'common-frontend'
import { SEOSettingsActions, SERPPreviewActions, PlusActions } from 'actions'
import { SEOSettingsStore, SERPPreviewStore, PlusStore } from 'stores'
import { TitleDescriptionPage } from 'pages'
import { HelpEmail } from 'components'

@connectToStores
export default class TitleDescriptionContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static getStores() {
    return [
      SEOSettingsStore,
      SERPPreviewStore,
      PlusStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState(),
      ...SERPPreviewStore.getState(),
      ...PlusStore.getState(),
    }
  }

  state = {
    showRequestedManualInstallDialog: false
  }

  componentWillMount() {
    if (!this.props.settings) {
      SEOSettingsActions.fetch()
    }
    PlusActions.fetch()    
  }

  handleRequestInstall = () => {
    PlusActions.requestPlusInstall(this.context.currentUser)
    PlusActions.fetch()

    this.setState({ showRequestedManualInstallDialog: true })
  }

  // Only used when requesting via the preview
  maybeShowRequestManualInstallRequestedDialog() {
    return this.state.showRequestedManualInstallDialog &&
      (
        <ResponsiveDialog
          title="Your Request is Sent"
          maxWidth="600px"
          modal={true}
          open={true}
          onRequestClose={() => this.setState({ showRequestedManualInstallDialog: false })}
        >
          <div>
            <div className="large-spacing2">
              <p>One of our team members will email you within 24 hours to help you add this last piece of Plug in SEO code to your theme.</p>
              <p className="medium-spacing--top">Need any more help? Email us at <HelpEmail/></p>
            </div>

            <Button label="Close"
              buttonType="secondary"
              onTouchTap={() => this.setState({ showRequestedManualInstallDialog: false })} />
          </div>
        </ResponsiveDialog>
      )
  }

  render() {
    return (
      <div>
        <TitleDescriptionPage
          settings={this.props.settings}
          fetching={this.props.fetching}
          previews={this.props.previews}
          fetchingPreviews={this.props.fetchingPreviews}
          installed={this.props.status.installed}
          isInstalling={this.props.isInstalling}
          failed={this.props.failed}
          status={this.props.status}
          currentUser={this.context.currentUser}
          handleRequestInstall={this.handleRequestInstall}
        />
        { this.maybeShowRequestManualInstallRequestedDialog() }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/plus/TitleDescriptionContainer.js